import { PasswordStrength } from "../fields/passwordStrength";
import { toggleValidStep } from '../../actions';
import { EVENT_NAME_STEP_VALIDATE } from "../../helpers/consts";
import { StepTitle } from "../stepTitle";

export class PasswordStep {
    /**
     * Component that handles the password step
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     * @param {string} options.id - Step id string
     */
    constructor(options) {
        this.store = options.store;
        this.isValid = false;
        this.translations = options.translations;
        this.id = options.id;
        this.createStep();
        this.validateStep();
        this.store.subscribe(this.update.bind(this));
    }

    createStep() {
        const $fieldSet = document.createElement('div');
        const fieldSetHTML = `
    <div class="row">
        <div class="col-12 col--field--password"></div>
    </div>
        `;
        $fieldSet.classList.add('fieldset');
        $fieldSet.innerHTML = fieldSetHTML;

        this.$stepTitle = new StepTitle({
            store: this.store,
            titleId: `${this.id}_title`,
            title: this.translations.step_4 ? this.translations.step_4 : __('Hi %s, choose your password for secure access to your Exact Online'),
        });

        this.$passwordStrength = new PasswordStrength({
            store: this.store,
            stepId: this.id,
            $context: $fieldSet,
        });

        $fieldSet.querySelector('.col--field--password').appendChild(this.$passwordStrength.render());

        $fieldSet.addEventListener(EVENT_NAME_STEP_VALIDATE, this.validateStep.bind(this));

        this.$el = $fieldSet;
    }

    validateStep() {
        this.isValid = this.$passwordStrength.valid();
        this.store.dispatch(toggleValidStep(this.id, this.isValid));
    }

    render() {
        return this.$el;
    }

    update() {
        this.state = this.store.getState();
    }
}

export default PasswordStep;
